import React, { useState } from "react";
import OptionMenu from "./OptionMenu";
import editIcon from "../assets/editIcon.png";
import "react-circular-progressbar/dist/styles.css";
import CircularProgress from "./CircularProgress";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import ConfirmationModal from "./ConfirmationModal";

export function formatarValor(valor, moeda = "BRL") {
  const formatador = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: moeda,
  });
  return formatador.format(valor);
}

const OrderTable = ({ orders }) => {
  const [orderId, setOrderId] = useState(null);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(null);
  const year = new Date().getFullYear();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const toggleMenu = (index, orderId) => {
    setIsOpen(isOpen === index ? null : index);
    setOrderId(orderId);
  };

  const handleNavigateDetails = (id, index) => {
    navigate(`/pedidos/detalhes/${id}/${index}`);
  };

  const handleDeleteOrder = async (id) => {
    try {
      console.log("id: ", id);
      await api.delete(`/orders/delete-order/id/${id}`);

      setIsModalOpen(false);
      navigate("/pedidos", { replace: true });
      navigate(0);
    } catch (error) {
      setErrorMessage(
        error.status === 400
          ? error.response.data.message
          : "Não foi possível excluir o pedido"
      );
      console.error("Erro ao excluir pedido: ", error);
      return true;
    }
  };

  return (
    <>
      {isModalOpen && (
        <ConfirmationModal
          onClose={() => setIsModalOpen(false)}
          onConfirm={() => handleDeleteOrder(orderId)}
          errorMessage={errorMessage}
        />
      )}
      <div className="xl:px-4 xl:pb-4 xl:pt-12 md:pt-6 bg-[#F2F2F2] rounded-md mt-4 overflow-y-auto custom-scrollbar max-h-[680px]">
        {orders.length === 0 && (
          <div>
            <p className="text-center text-2xl font-bold text-boldGray opacity-90 pb-4">
              Ainda não existem pedidos
            </p>
          </div>
        )}
        <table className="w-full table-auto border-collapse text-boldGray opacity-90">
          <thead className="min-h-[44px] border-b border-lightGray ">
            <tr className="uppercase bold text-base md:text-xs xl:text-base min-h-[44px]">
              <th className=" px-4 py-2"></th>
              <th className="md:px-2 px-4 py-2">Pedido</th>
              <th className=" md:px-2 px-4 py-2">Fornecedor</th>
              <th className=" md:px-2 px-4 py-2">Descrição do Pedido</th>
              <th className=" md:px-2 px-4 py-2">Status</th>
              <th className=" md:px-2 px-4 py-2">Valor Total ($)</th>
              <th className=" md:px-2 px-4 py-2">Forma de pagamento</th>
              <th className="md:px-2 px-4 py-2"></th>
            </tr>
          </thead>
          <tbody className="space-y-4 ">
            <tr>
              <td className="h-[20px]"></td>
              <td className="h-[20px]"></td>
              <td className="h-[20px]"></td>
              <td className="h-[20px]"></td>
              <td className="h-[20px]"></td>
              <td className="h-[20px]"></td>
              <td className="h-[20px]"></td>
              <td className="h-[20px]"></td>
              <td className="h-[20px]"></td>
            </tr>
            {orders ? (
              orders.map((order, index) => (
                <React.Fragment key={index}>
                  <tr
                    className="text-center bg-[#E7E7E7] w-full cursor-pointer h-[64px] text-xs md:text-xs "
                    onClick={() => handleNavigateDetails(order.id, index + 1)}
                  >
                    <td
                      className="  flex justify-center items-center"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <button
                        onClick={() => toggleMenu(index, order.id)}
                        className="h-[64px] flex items-center justify-center"
                      >
                        <img src={editIcon} alt="" />
                      </button>
                      {isOpen === index && (
                        <OptionMenu
                          setter={setIsOpen}
                          orderId={orderId}
                          setIsModalOpen={setIsModalOpen}
                        />
                      )}
                    </td>
                    <td className="  font-bold">
                      P00{index + 1}-{year}{" "}
                    </td>
                    <td className="uppercase">{order.supplier_name}</td>
                    <td className="flex justify-center">
                      {(() => {
                        let text = order.order_Items
                          .map((item) => item.product.name)
                          .join(", ");

                        return text.length > 100
                          ? text.substring(0, 200) + "..."
                          : text;
                      })()}
                    </td>

                    <td className=" ">{order.status.replace("_", " ")}</td>
                    <td className=" ">
                      {formatarValor(order.order_total, "USD")}
                    </td>
                    <td className=" ">{order.payment_method?.name}</td>

                    <td>
                      <CircularProgress status={order.status} />
                    </td>
                  </tr>
                  {index !== orders.length - 1 && (
                    <tr>
                      <td className="h-[10px]"></td>
                    </tr>
                  )}
                </React.Fragment>
              ))
            ) : (
              <div>teste</div>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default OrderTable;
